import React, { useEffect, useRef } from "react"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  InputGroupAddon,
  InputGroup,
  Input,
} from "reactstrap"
import NotificationAlert from "react-notification-alert"

import { Constants } from "scripts"
import { usePrevious } from "components/Common"

const OrderSummary = ({
  merchant,
  selectedItems,
  totalCost,
  promoCode,
  setPromoCode, // Setting State In Parent Component
  setPromoCodeInfo, // Setting State In Parent Component
  setDiscountCost, // Setting State In Parent Component
  fetchPromoCode,
  promoCodeInfo,
  fetchClientSecret,
}) => {
  const {
    data: promoCodeData,
    error: promoCodeError,
    message: promoCodeMessage,
  } = promoCodeInfo

  // ===== Discount Cost =====
  const discountCost = getDiscountCost(promoCodeData, totalCost)
  const prevDiscountCost = usePrevious(discountCost)
  useEffect(() => {
    if (discountCost && discountCost !== prevDiscountCost) {
      setDiscountCost(discountCost)
    }
  })

  // ===== Notification Alert =====
  const notificationAlertRef = useRef(null)
  const notify = (type, message, title) => {
    const options = Constants.NotificationAlertOptions(type, message, title)
    notificationAlertRef.current.notificationAlert(options)
  }

  // ===== promoCodeMessage && promoCodeError useEffect =====
  useEffect(() => {
    if (promoCodeMessage) {
      console.log("Promo Code Message Via Use Effect")
      notify("danger", promoCodeMessage, "Warning")
    }
  }, [promoCodeMessage])
  useEffect(() => {
    if (promoCodeError) {
      console.log("Promo Code Error Via Use Effect")
      notify("danger", promoCodeError, "Warning")
    }
  }, [promoCodeError])

  // ===== promoCodeData useEffect =====
  const prevPromoCodeData = usePrevious(promoCodeData)
  useEffect(() => {
    if (
      promoCodeData &&
      JSON.stringify(promoCodeData) !== JSON.stringify(prevPromoCodeData) &&
      discountCost > 0
    ) {
      console.log("Promo Code Success Via Use Effect")
      notify("success", "Promo Code Applied", "Notification")
      fetchClientSecret(discountCost) // Fetching And Setting Client Secret, AGAIN, When Promo Code Is Applied
    }
  })

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      {merchant && selectedItems && totalCost && (
        <Card>
          <CardBody>
            <CardTitle className="mb-3 text-primary" tag="h3">
              Order Summary
            </CardTitle>
            <CardText className="mb-2 chift-card-text">
              <span className="h4">{merchant.name || ""}</span>
            </CardText>
            <CardText className="mb-0 chift-card-text">
              {selectedItems.vehicleType && (
                <>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="h4">{selectedItems.vehicleType.title}</span>
                </>
              )}
            </CardText>
            <CardText className="mb-0 chift-card-text">
              {selectedItems.package && (
                <>
                  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="h4">{selectedItems.package.title}</span>
                  <span className="h4 mr-5 float-right text-muted">
                    {"$" + selectedItems.package.cost}
                  </span>
                  <span className="clearfix"></span>
                </>
              )}
            </CardText>
            {selectedItems.addon && (
              <>
                {selectedItems.addon.map((addon, key) => {
                  return (
                    <CardText
                      className="chift-card-text mb-0 w-100"
                      key={`${addon.title}-${key}`}
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                      <span className="h4">{addon.title}</span>
                      <span className="h4 mr-5 float-right text-muted">
                        {"+$" + addon.cost}
                      </span>
                      <span className="clearfix"></span>
                    </CardText>
                  )
                })}
              </>
            )}
            {promoCodeData ? (
              <CardText className="chift-card-text mb-0 w-100 position-relative">
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="h4 text-success">
                  Promo Code: {promoCodeData.title}
                </span>
                <span className="h4 mr-5 float-right text-muted">
                  {"-$" + discountCost}
                  <Button
                    className="position-absolute"
                    close
                    onClick={() => {
                      console.log("Remove Promo Code")
                      setPromoCode("")
                      setDiscountCost(0)
                      setPromoCodeInfo({})
                    }}
                    style={{
                      right: 3,
                    }}
                  />
                </span>
                <span className="clearfix"></span>
              </CardText>
            ) : (
              <>
                <Row className="text-center">
                  <Col>
                    <InputGroup>
                      <Input
                        size="sm"
                        autoComplete="off"
                        id="promo-code"
                        onChange={(e) => {
                          setPromoCode(e.target.value)
                          if (promoCodeMessage) {
                            setPromoCodeInfo({})
                          }
                          if (promoCodeError) {
                            setPromoCodeInfo({})
                          }
                        }}
                        placeholder="Use Promo Code"
                        type="text"
                        value={promoCode}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => {
                            const devMsg = "Order Summary - Apply Button -"
                            console.log(`${devMsg} Clicked`)
                            console.log(promoCode || `${devMsg} No Promo Code`)
                            console.log(
                              promoCodeMessage ||
                                `${devMsg} No Promo Code Message`
                            )
                            if (promoCode) {
                              if (promoCodeMessage) {
                                console.log(`${devMsg} Debug - 1`)
                                notify("danger", promoCodeMessage, "Warning")
                              } else if (promoCodeError) {
                                console.log(`${devMsg} Debug - 2`)
                                notify("danger", promoCodeError, "Warning")
                              } else if (promoCode.length >= 4) {
                                console.log(`${devMsg} Debug - 3`)
                                fetchPromoCode({ promoCode })
                              } else {
                                console.log(`${devMsg} Debug - 4`)
                                notify(
                                  "danger",
                                  "Please Use A Valid Promo Code",
                                  "Warning"
                                )
                              }
                            } else {
                              console.log(`${devMsg} Debug - 4`)
                              notify(
                                "danger",
                                "Please Use A Valid Promo Code",
                                "Warning"
                              )
                            }
                          }}
                        >
                          Apply
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </Col>
                </Row>
              </>
            )}
            <hr className="my-3" />
            <CardTitle className="mb-3 text-primary" tag="h4">
              Total
              <span className="float-right mr-5">
                {"$" + (parseInt(totalCost) - discountCost)}
              </span>
              <span className="clearfix"></span>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </>
  )
}

const getDiscountCost = (promoCodeData, totalCost) => {
  if (promoCodeData) {
    const discount = parseInt(promoCodeData.discount)
    switch (promoCodeData.type) {
      case "direct":
        return discount
      case "percentage":
        if (totalCost) {
          return Math.ceil((parseInt(totalCost) * discount) / 100)
        }
        return 0
      default:
        return 0
    }
  }
  return 0
}

export default OrderSummary
